module.exports = __webpack_public_path__ + "img/icon_close.f3bbed63.svg";